import Reveal, { usePageMeta } from "@/components/Reveal";

function LegalShell({ eyebrow, title, children, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20 sm:py-28" data-testid={testId}>
      <Reveal>
        <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37] mb-5">{eyebrow}</p>
        <h1 className="font-display font-light text-4xl sm:text-5xl text-[#F6F1E6] mb-12">{title}</h1>
      </Reveal>
      <div className="space-y-10 text-sm text-[#B9BFD0] leading-relaxed">{children}</div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl text-[#E5C158] mb-3">{title}</h2>
      {children}
    </section>
  );
}

export function MentionsLegales() {
  usePageMeta("Mentions légales", "Mentions légales du site Golden Aura Pro, conciergerie location courte durée.");
  return (
    <LegalShell eyebrow="Informations légales" title="Mentions légales" testId="legal-page">
      <Section title="Éditeur du site">
        <p>GOLDEN AURA — SAS (société par actions simplifiée), enseigne « Golden Aura Pro »</p>
        <p>Conciergerie &amp; location de courte durée — Activité : services administratifs combinés (82.11Z)</p>
        <p>Siège social : 15 rue Courteline, 01100 Oyonnax, France</p>
        <p>SIRET : 103 315 339 00012 · Immatriculée le 30 mars 2026</p>
        <p>Directrice de la publication : Dulce Semedo Monteiro, Présidente</p>
        <p>E-mail : <a href="mailto:goldenauraprof@gmail.com" className="text-[#E5C158] underline underline-offset-2">goldenauraprof@gmail.com</a> · Tél. : <a href="tel:+33619307868" className="text-[#E5C158] underline underline-offset-2">+33 6 19 30 78 68</a></p>
      </Section>
      <Section title="Hébergement du site">
        <p>Ce site est conçu et hébergé via la plateforme Emergent (emergent.sh), sur une infrastructure cloud sécurisée.</p>
        <p>La connexion au site est sécurisée par le protocole HTTPS (certificat SSL).</p>
      </Section>
      <Section title="Propriété intellectuelle">
        <p>L'ensemble des contenus du site (textes, visuels, logo, charte graphique) est la propriété exclusive de Golden Aura Pro, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.</p>
      </Section>
      <Section title="Réservations et paiements">
        <p>Aucune réservation ni aucun paiement n'est effectué sur ce site. Les réservations sont réalisées directement sur les plateformes partenaires (Airbnb, Booking.com), soumises à leurs propres conditions générales. Ce site ne collecte aucune donnée bancaire.</p>
      </Section>
      <Section title="Responsabilité">
        <p>Golden Aura Pro s'efforce d'assurer l'exactitude des informations publiées, sans pouvoir en garantir l'exhaustivité. L'éditeur ne saurait être tenu responsable des contenus des sites tiers vers lesquels des liens pointent.</p>
      </Section>
    </LegalShell>
  );
}

export function Confidentialite() {
  usePageMeta("Politique de confidentialité", "Politique de confidentialité et protection des données personnelles (RGPD) du site Golden Aura Pro.");
  return (
    <LegalShell eyebrow="Protection des données" title="Politique de confidentialité" testId="privacy-page">
      <Section title="Responsable du traitement">
        <p>GOLDEN AURA (SAS) — enseigne « Golden Aura Pro » — 15 rue Courteline, 01100 Oyonnax — E-mail : <a href="mailto:goldenauraprof@gmail.com" className="text-[#E5C158] underline underline-offset-2">goldenauraprof@gmail.com</a></p>
      </Section>
      <Section title="Données collectées">
        <p>Via le formulaire de contact uniquement : nom et prénom, adresse e-mail, numéro de téléphone (facultatif), objet et contenu de votre message. Ces données servent exclusivement à répondre à votre demande.</p>
        <p>Aucune donnée bancaire n'est collectée : les réservations et paiements s'effectuent directement sur Airbnb ou Booking.com.</p>
      </Section>
      <Section title="Base légale et durée de conservation">
        <p>Le traitement repose sur votre consentement (case à cocher du formulaire) et sur l'intérêt légitime de répondre à vos demandes. Les messages sont conservés 24 mois maximum, puis supprimés.</p>
      </Section>
      <Section title="Destinataires et sous-traitants">
        <p>Vos données sont transmises uniquement à Golden Aura Pro. L'envoi des e-mails est assuré par un prestataire technique d'acheminement (service d'e-mailing transactionnel), dans le respect du RGPD. Aucune donnée n'est vendue ni cédée à des tiers à des fins commerciales.</p>
      </Section>
      <Section title="Vos droits (RGPD)">
        <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Pour les exercer : <a href="mailto:goldenauraprof@gmail.com" className="text-[#E5C158] underline underline-offset-2">goldenauraprof@gmail.com</a>. Vous pouvez également saisir la CNIL (www.cnil.fr).</p>
      </Section>
      <Section title="Cookies">
        <p>Ce site n'utilise ni cookies publicitaires, ni cookies de mesure d'audience tiers. Seuls des stockages techniques strictement nécessaires au fonctionnement (choix de consentement, session administrateur) sont utilisés, dispensés de consentement préalable. Le bandeau affiché lors de votre première visite vous permet de mémoriser votre choix.</p>
      </Section>
      <Section title="Sécurité">
        <p>Le site fonctionne en HTTPS, les données transmises sont chiffrées, le formulaire est protégé contre les envois automatisés (limitation de débit et champ anti-spam) et les accès d'administration sont protégés par mot de passe chiffré.</p>
      </Section>
    </LegalShell>
  );
}
